import FilterHeader from "../../Shared/FilterHeader/FilterHeader";
import ListingCard from "../Common/ListingCard";
import MessageInput from "./MessageInput";
import SelfMessage from "./SelfMessage";
import UserInfo from "./UserInfo";
import UserMessage from "./UserMessage";

const MessageChat = () => {
  return (
    <div className="col-span-3 mt-[60px]">
      <FilterHeader title={"My Messages"} className="mb-5" />

      <ListingCard description="Lorem ipsum dolor sit amet consectetur. Sagittis sed sollicitudin feugiat sociis mattis ante non metus." />
      <div className="mt-2.5 mb-[60px]">
        <UserInfo />

        <div className=" border border-t-0 border-lightGray px-8 pt-8 pb-9">
          <UserMessage text="Hey Joy, I’m interested" />
          <SelfMessage text="Yes, I am Fine. And you?" />
          <UserMessage text="Yeah. Am so so." />
          <SelfMessage text="Coolllll. What your last price for this?" />
          <UserMessage text="I can do R500,00 just for you." />
          <SelfMessage text="Alright, we can have a deal now." />
          <MessageInput />
        </div>
      </div>
    </div>
  );
};

export default MessageChat;
